import { connect } from 'react-redux';
import PainelDeVendas from './painelDeVendas';

export default connect()(PainelDeVendas);
